import { __read } from "tslib";
import { mergeClasses } from '@fluentui/react-components';
import React from 'react';
import { useFirstRunGreetingsStyles } from './FirstRunGreetings.styles';
import { FirstRunImage } from './FirstRunImage';
import { applyTextHighlights } from './helpers/applyTextHighlights';
export var FirstRunGreetings = function (_a) {
    var config = _a.config, active = _a.active, setIsGreetingsActive = _a.setIsGreetingsActive, themeMode = _a.themeMode, context = _a.context;
    var greetings = config.greetings;
    var _b = __read(React.useState(0), 2), greetingsIdx = _b[0], setGreetingsIdx = _b[1];
    var idxRef = React.useRef(greetingsIdx);
    idxRef.current = greetingsIdx;
    React.useLayoutEffect(function () {
        var GreetingsInterval = 1600;
        var GreetingsIntervalDelay = 1200;
        var greetingsTimerId;
        setTimeout(function () {
            greetingsTimerId = setInterval(function () {
                setGreetingsIdx(idxRef.current + 1);
                if (idxRef.current >= greetings.length) {
                    setIsGreetingsActive();
                    clearInterval(greetingsTimerId);
                }
            }, GreetingsInterval);
        }, GreetingsIntervalDelay);
        return function () { return clearInterval(greetingsTimerId); };
    }, []);
    var styles = useFirstRunGreetingsStyles();
    var containerStyle = React.useMemo(function () {
        return mergeClasses(styles.container, active && styles.containerActive);
    }, [styles.container, styles.containerActive, active]);
    var textContainerActive = React.useMemo(function () {
        return mergeClasses(styles.textContainer, styles.textContainerActive);
    }, [styles.textContainer, styles.textContainerActive]);
    var greetingsContent = React.useMemo(function () {
        return (React.createElement("div", { "data-testid": "first-run-greetings", className: containerStyle },
            React.createElement("div", { className: styles.iconContainer },
                React.createElement(FirstRunImage, { imgConfig: config.icons.brandIcon, themeMode: themeMode, context: context })),
            React.createElement("div", { className: styles.textWrapper }, greetings.map(function (greeting, idx) { return (React.createElement("div", { className: idx === greetingsIdx
                    ? textContainerActive
                    : styles.textContainer, key: idx },
                React.createElement("p", null, applyTextHighlights(greeting)))); }))));
    }, [
        containerStyle,
        styles,
        config,
        themeMode,
        context,
        greetings,
        greetingsIdx,
        textContainerActive,
    ]);
    return greetingsContent;
};
//# sourceMappingURL=FirstRunGreetings.js.map